$(function(){
    $.get('/cart', function(result){
        var PageText = $(result).find('#finalshowitemcount').text();
        $('.cart div').text(PageText).css('opacity', 1);
    });
});

document.addEventListener('DOMContentLoaded', function(){
// console.log('in');
    function footeraccordion() {   
        if ($(window).width() <= 1024){
            $(".footer__menu-title").click(function () {
                var ctitle = $(this); 
                var ctitleparent = ctitle.parent();
                if( ctitleparent.hasClass('open')){
                    ctitleparent.removeClass('open');
                    ctitle.next().slideUp(400);
                }else{
                    $(".footer__menu-title").not(this).parent().removeClass('open');
                    $(".footer__menu-title").not(this).next().slideUp(400);
                    ctitleparent.addClass('open');
                    ctitle.next().slideDown(400);
                }
            });
        }
    }
   
   
    footeraccordion();
    $('#page-menu').scroll(function() {
    var checktopscroll = $("#page-menu .inner_growth-area").offset().top;
        if( checktopscroll < 72) {
            if(! $('body').hasClass('modal_scroll_effect') ){
                $('body').addClass('modal_scroll_effect');
            }
        }else{
            $('body').removeClass('modal_scroll_effect');
        }
    })

  // -------------- Ritika edits start for  JINS REVIVE lens type & usage logic  Task
        let all_lineGroups = []; // global variable
        async function get_all_lineGroups(){
            await  jQuery.getJSON('/cart.js', function(cart) {
 
                let items = cart.items;                
                for(var i=0; i < items.length; i++){
                    // console.log(items[i].properties);
                    switch (items[i].properties.line_type) {
                        case "frame_id":
                           // console.log("enter");
                           // console.log(items[i].properties.lens_type);
                            all_lineGroups.push(items[i].properties.lens_type);
                        break;
                    }
                }          
             
            });
        }
    // -------------- Ritika edits end for  JINS REVIVE lens type & usage logic Task
    $('.add-revive-btn').on('click', async function(event){
        event.preventDefault();
            var Id=$('.revive__prod-container').find('.active').attr('data-variant');
            var lens_type_usage = '';
            var lens_options = $('.revive__prod-container').find('.active .lens_options').text();
             // -------------- Ritika edits start for  JINS REVIVE lens type & usage logic  Task
           await get_all_lineGroups();
            //console.log(all_lineGroups);
            if(all_lineGroups.includes("Readers")){
                lens_type_usage = "Readers";
            }else  if(all_lineGroups.includes("Single Vision")){
                lens_type_usage = "Single Vision";
            }else  if(all_lineGroups.includes("Progressive")){
                lens_type_usage = "Progressive";
            }else  if(all_lineGroups.includes("Non-prescription")){
                lens_type_usage = "Non-prescription";
            }
            // console.log(lens_type_usage);
            // ---------------- Ritika edits end for  JINS REVIVE lens type&usage logic  Task      
            $.ajax({
            type :'POST',
            url :'cart/add.js',
            data: {
                id: Id,
                properties: {
                    "Lens Option": lens_options,
                    "Lens Type & Usage" : lens_type_usage
                }
            },
            dataType :'json',
            success : function(data){
                location.reload();
            }
        });
    });

    $('.cstm-high-index-box div').on('click',function(){
        $(this).toggleClass('active').siblings().removeClass('active');
    });
    $('.revive_modal_triggerer').on('click',function(event){
        $('.revive_modal').addClass('modal-show');
        $('body').addClass('revivemodal-open');
    });
    $('.no_revive').on('click',function(event){
        $('.revive_modal').removeClass('modal-show');
        $('body').removeClass('revivemodal-open');
    });

    $('.add-revive-btn_modal').on('click',async function(event){
        event.preventDefault();
            var Id=$('.revive__prod-container_modal').find('.active').attr('data-variant');
            var lens_type_usage = '';
            var lens_options = $('.revive__prod-container_modal').find('.active .lens_options').text();
          // -------------- Ritika edits start for  JINS REVIVE lens type & usage logic  Task
           await get_all_lineGroups();
            //console.log(all_lineGroups);
            if(all_lineGroups.includes("Readers")){
                lens_type_usage = "Readers";
            }else  if(all_lineGroups.includes("Single Vision")){
                lens_type_usage = "Single Vision";
            }else  if(all_lineGroups.includes("Progressive")){
                lens_type_usage = "Progressive";
            }else  if(all_lineGroups.includes("Non-prescription")){
                lens_type_usage = "Non-prescription";
            }
            // console.log(lens_type_usage);
            // ---------------- Ritika edits end for  JINS REVIVE lens type&usage logic  Task      
            $.ajax({
            type :'POST',
            url :'cart/add.js',
            data: {
                id: Id,
                properties: {
                    "Lens Option": lens_options,
                    "Lens Type & Usage" : lens_type_usage
                }
            },
            dataType :'json',
            success : function(data){
                location.reload();
            }
        });
    });

    $('.cstm-high-index-box_modal .cstm-high-index').on('click',function(){
            $(this).addClass('active').siblings().removeClass('active');
    });
    
    // $('.delete_customer').on('click',function(){
    // //    console.log("Ritika : Commando let's delete the customer");
    //    localStorage.setItem("sessionOUT", "yes");
    //    window.location.href = JINS_SSO_DOMAIN + 'us/en/unsubscribe?service_id=jins_ec_us2';
    // });

  //for accessibility trigger on other pages
  var value;
    if (localStorage.getItem("accessibility")) {
      var value = localStorage.getItem("accessibility");
        if (value) {
          setTimeout(function () {
         $('#accessibly-trigger').click(); 
          }, 1000)
     }
  }
  $('#accessibly-trigger').click(function() {
    localStorage.setItem('accessibility', 'true');
  })
});
